import React, { useState, useEffect } from 'react';
import {
    Autocomplete, Box, Button, Drawer, Stack, TextField, Tooltip,
    Typography, Grow, FormControlLabel, Checkbox,
    IconButton,
    Menu,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { withTranslation } from 'react-i18next';
import { AmountsCard } from '../../../Components/CommonCards/CommonCards';
import { ImagePaths } from '../../../Utility/ImagePaths';
import CommonDatePicker from '../../../Components/Common Components/CommonDatePicker';
import { CommonGridToolBarWithFilterText, ReasonPopup } from '../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import { formatDate, AmountFormat, splitDate } from '../../../Components/CommonFunctions/CommonFunctions';
import { Colors } from '../../../Styles/Colors';
import { CurrencySymbol } from '../../../Utility/Constants';
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useHistory } from 'react-router-dom';
import { setCachevalue } from '../../../Utility/Services/CacheProviderService';


const OTOverallBills = (props) => {
    const history = useHistory();
    const [state, setState] = useState({
        OverallBillDataList: [],
        page: 0,
        pageSize: 10,
        filterDatas: {
            'fromDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            'toDate': DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            "dateIndex": 1,
            "patientName": '',
            "uhid": '',
            "days": null,
            'billFrom': '',
            'billTo': '',
            'bill_type': ""
        },
        filterOpen: false,
        isLoader: false,
        disableBtn: false,
        isErrorMsg: false,
        isErrorMsgText: "",
        successMsg: false,
        successMsgText: "",
        triggerAction: null,
        selectedCancelBill: null,
        selcetedModifyBill: null,
        totalAmount: 0,
        totalBills: 0,
    })

    useEffect(() => {
        getOtOverallBillData();
    }, []);

    useEffect(() => {
        if (state.triggerAction) {
            getOtOverallBillData();
            setState((prevState) => ({
                ...prevState,
                triggerAction: null
            }))
        }
    }, [state.triggerAction])

    const generateUrl = () => {
        const { filterDatas } = state;
        const UHID = filterDatas?.uhid?.replaceAll('&', '%26');

        return Serviceurls.OT_OVERALL_BILLS_REPORT +
            `?from_date=${filterDatas.fromDate}&to_date=${filterDatas.toDate}&patient_name=${filterDatas.patientName}&account_number=${UHID}&bill_no_from=${filterDatas.billFrom}&bill_no_to=${filterDatas.billTo}&bill_type=${filterDatas.bill_type}`
    }

    const getOtOverallBillData = () => {
        try {
            LoaderFunction(true);
            const url = generateUrl();
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response.data.status === 'success') {
                        LoaderFunction(false);
                        const data = response.data.data || [];
                        data?.forEach((element, index) => {
                            element.sno = index + 1;
                        })
                        setState((prevState) => ({
                            ...prevState,
                            OverallBillDataList: data,
                            totalAmount: response?.data?.total_amount,
                            totalBills: response?.data?.no_of_bill,
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        LoaderFunction(false);
                        errorMessage(error.response.data.message)
                    } else {
                        LoaderFunction(false);
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            LoaderFunction(false);
            errorMessage(error.message)
        }
    }


    const getSalesDetailedPrint = () => {
        try {
            const url = generateUrl();
            setDisableBtn(true);
            RestAPIService.PrintPDF(`${url}&export=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    setDisableBtn(false);
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setDisableBtn(false);
                })
        } catch (error) {
            errorMessage(error.message)
            setDisableBtn(false);
        }
    }

    const getSalesDetailedExcel = () => {
        try {
            setDisableBtn(true);
            const url = generateUrl();
            RestAPIService.excelGet(`${url}&export=excel`)
                .then((response) => {
                    if (response.data) {
                        const pom = document.createElement('a');
                        const csvContent = response.data; //here we load our csv data 

                        const filename = response.headers["content-disposition"].split("filename=")[1]

                        const blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
                        const url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'registry.xlsx');
                        pom.click();
                        setDisableBtn(false);
                    }
                }).catch((error) => {
                    if (error.response?.data?.message) {
                        errorMessage(error.response?.data?.message);
                    } else {
                        errorMessage(error.message);
                    }
                    setDisableBtn(false);
                })
        } catch (error) {
            errorMessage(error.message);
            setDisableBtn(false);
        }
    }

    const setDisableBtn = (key) => {
        setState((prevState) => ({
            ...prevState,
            disableBtn: key
        }))
    }

    const LoaderFunction = (key) => {
        setState((prevState) => ({
            ...prevState,
            isLoader: key
        }))
    }

    const errorMessage = (message) => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: true,
            isErrorMsgText: message
        }))
        LoaderFunction(false);
    }

    const successMessage = (message) => {
        setState((prevState) => ({
            ...prevState,
            successMsg: true,
            successMsgText: message,
        }))
    }

    const msgClose = () => {
        setState((prevState) => ({
            ...prevState,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        }))
    }

    const gridToolBar = () => {
        const TextArray = [
            { label: "From Date", value: formatDate(state.filterDatas.fromDate) },
            { label: "To Date", value: formatDate(state.filterDatas.toDate) },
        ]
        return (
            <Box>
                <CommonGridToolBarWithFilterText FilterTextArray={TextArray} noExport={true} />
            </Box>
        )
    }

    const closeFilter = (fromSrch) => {
        setState((prevState) => ({
            ...prevState,
            filterOpen: false,
            triggerAction: fromSrch ? "search" : null
        }))
    }

    const FilterDate = (from, to, index) => {
        setState((prevState) => ({
            ...prevState,
            filterDatas: {
                ...prevState.filterDatas,
                fromDate: from,
                toDate: to,
                dateIndex: index
            }
        }))
    }

    const onChangeHandler = (e) => {
        const { name, value } = e.target;

        let isValid = false;

        switch (name) {
            case 'billNumber':
            case 'billFrom':
            case 'billTo':
                isValid = CommonValidation.numberOnly(value) || value === '';
                break;
            case 'uhid':
                isValid = CommonValidation.ALPHA_NUM_SPLCHAR(value) || value === '';
                break;
            default:
                isValid = CommonValidation.alphabetOnly(value) || value === '';
                break;
        }

        if (isValid) {
            setState((prevState) => ({
                ...prevState,
                filterDatas: {
                    ...prevState.filterDatas,
                    [name]: value
                }
            }));
        }
    };

    const renderTextField = (label, stateKey) => {
        return (
            <TextField
                size='small'
                autoComplete='off'
                name={stateKey}
                fullWidth
                value={state.filterDatas[stateKey] || ""}
                label={label}
                inputProps={{ emed_tid: label }}
                onChange={(e) => { onChangeHandler(e) }}
            />
        )
    }

    const renderFilterScreen = () => {
        const { filterDatas } = state;
        const { t } = props;

        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { closeFilter() }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={filterDatas.fromDate}
                            ToDate={filterDatas.toDate}
                            DateIndex={filterDatas.dateIndex}
                            SelectedDates={FilterDate.bind(this)}
                            HideAllMenu={true} />
                    </Box>
                    <Box display={"grid"} gridTemplateColumns="repeat(2, 1fr)" gap={"0.5dvw"}>
                        {renderTextField("Patient Name", 'patientName')}
                        {renderTextField("UHID", 'uhid')}
                        {renderTextField('Bill No From', 'billFrom')}
                        {renderTextField('Bill No To', 'billTo')}
                    </Box>
                    <FormControl sx={{ width: '23vw', marginTop: "0.5vw" }} size='small'>
                        <InputLabel id="group-select">{"Bill Type"}</InputLabel>
                        <Select
                            labelId="group-select"
                            id="demo-simple-select"
                            value={state?.filterDatas?.bill_type}
                            label={"Bill Type"}
                            onChange={(event) => {
                                setState((prevState) => ({
                                    ...prevState,
                                    filterDatas: {
                                        ...prevState.filterDatas,
                                        bill_type: event.target.value
                                    }
                                }))
                            }}
                        >
                            <MenuItem value={""}>{"All"}</MenuItem>
                            <MenuItem value={"credit"}>{"Credit"}</MenuItem>
                            <MenuItem value={"cancelled"}>{"Cancelled"}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setState((prevState) => ({
                                ...prevState,
                                filterDatas: {
                                    ...prevState.filterDatas,
                                    fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                    toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                    dateIndex: 1,
                                    patientName: '',
                                    uhid: '',
                                    billFrom: '',
                                    billTo: '',
                                    bill_type: '',
                                },
                                triggerAction: "clear"
                            }));
                        }}
                        disabled={state.triggerAction === "clear"}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={state.triggerAction === "search"}
                        onClick={() => {
                            if (state.filterDatas.billTo < state.filterDatas.billFrom) {
                                errorMessage("Bill To No is less than Bill From No");
                            } else {
                                closeFilter(true);
                            }
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    const { t } = props;

    const closeMenu = () => {
        setState((prev) => ({
            ...prev,
            menuAnchorEl: null,
            menuRowId: null,
            isIssueDrug: false,
        }))
    }

    const CancelOtBill = (remarks) => {
        try {
            LoaderFunction(true);
            let data = {
                "id": state?.selectedCancelBill?.id || null,
                "bill_type": "cancelled",
                "cancel_reason": remarks || "",
            }
            RestAPIService.create(data, Serviceurls.OT_BILLING_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        LoaderFunction(false);
                        successMessage(response?.data?.message)
                        setState((prevstate) => ({
                            ...prevstate,
                            selectedCancelBill: null,
                            menuAnchorEl: null,
                            menuRowId: null,
                        }))
                        getOtOverallBillData()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })

        } catch (e) {
            errorMessage(e.message)
        }
    }

    const popClose = () => {
        setState((prevstate) => ({ ...prevstate, selectedCancelBill: null }))
    }

    const GetOverallPrint = (data) => {
        try {
            RestAPIService.getAllPrint(Serviceurls.GET_PRINT_PREVIEW + `?id=${data?.id}&export=pdf`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error?.message)
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const MenuItemTbl = (data) => {
        const multi_option = [
            { value: "modifyBill", label: "Modify Bills" },
            { value: "cancelBill", label: "Cancel Bills" },
        ]
        return (
            <div key={`menu-${data?.id}`}>
                <Tooltip title={"More"} placement='top' arrow>
                    <IconButton
                        disabled={data?.payment_status !== "not paid" || data?.bill_type !== "credit"}
                        onClick={(e) => {
                            setState((prev) => ({
                                ...prev,
                                menuAnchorEl: e.currentTarget,
                                menuRowId: data.id,
                            }));
                        }}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </Tooltip>
                {(state.menuAnchorEl && state.menuRowId === data.id) ?
                    <Menu
                        anchorEl={state.menuAnchorEl}
                        open={state.menuRowId === data.id}
                        onClose={closeMenu}>
                        {multi_option?.map((option) => (
                            <MenuItem key={option.value}
                                disabled={false}
                                onClick={() => {
                                    if (option?.value === "modifyBill") {
                                        setCachevalue(true, "isForCancelBill")
                                        setCachevalue(JSON.stringify(data), "OTpatientData")
                                        history.push({ pathname: "/OTHome/Billing", state: { fromModifyBill: true, BillData: data } })
                                    } else if (option?.value === "cancelBill") {
                                        setState((prevstate) => ({ ...prevstate, selectedCancelBill: data }))
                                    }
                                }}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Menu> : null}
            </div>
        )
    }
    const columns = [
        {
            field: 'invoice_date', headerName: "Date And Time", flex: 0.12,
            renderCell: ({ row }) => (<Box component={'div'}>
                {row?.invoice_date ? row?.invoice_date : '-'}
            </Box>)
        },
        {
            field: 'bill_number', headerName: "Bill Number", flex: 0.14,
            renderCell: ({ row }) => (<Box component={'div'}>
                {row?.bill_number?.length > 20 ? <Tooltip placement='top' title={row?.bill_number} arrow>
                    <div>{row?.bill_number?.slice(0, 20) + '...'}</div></Tooltip> :
                    row?.bill_number ? row?.bill_number : '-'}
            </Box>)
        },
        {
            field: 'patient_name', headerName: "Patient Details", flex: 0.16,
            renderCell: ({ row }) => {
                let patientName = row?.patient_name ? row?.patient_name : "-"
                let accNumAndMob = (row?.patient_uhid ? row?.patient_uhid : "-") + "|" + (row?.patient_mobile_number ? row?.patient_mobile_number : "-")
                return (
                    <Box component={'div'} display={'flex'} emed_tid='emed_phar_pat_dtls' >
                        <Box component={'div'}>
                            {patientName ? patientName?.length > 10 ?
                                <Tooltip placement='top' title={patientName} arrow>
                                    <Typography fontSize={'0.9dvw'} fontWeight={600}>{patientName?.slice(0, 10) + "..."}</Typography>
                                </Tooltip> :
                                <Typography fontSize={'0.9dvw'} fontWeight={600}>{patientName}</Typography> : '-'}
                            {accNumAndMob ? accNumAndMob?.length > 20 ?
                                <Tooltip placement='top' title={accNumAndMob} arrow>
                                    <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>{accNumAndMob?.slice(0, 20) + "..."}</Typography>
                                </Tooltip> :
                                <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>{accNumAndMob}</Typography> : '-'}
                        </Box>
                    </Box>
                )
            }, valueGetter: (params) => {
                const Name = params.row?.patient_name || "";
                const Mobile = params.row?.mobile_no || "";
                const UHID = params.row?.patient_uhid || "";
                return `${Name} ${Mobile} ${UHID}`;
            }
        },
        {
            field: 'surgery_name', headerName: "Surgery Name", flex: 0.12,
            renderCell: ({ row }) => (<Box component={'div'}>
                {row?.surgery_name?.length > 20 ? <Tooltip placement='top' title={row?.surgery_name} arrow>
                    <div>{row?.surgery_name?.slice(0, 20) + '...'}</div></Tooltip> :
                    row?.surgery_name ? row?.surgery_name : '-'}
            </Box>)
        },
        {
            field: 'surgeon_name', headerName: 'Surgeon Name', flex: 0.12,
            renderCell: ({ row }) => (<Box component={'div'}>
                {row?.surgeon_name?.length > 20 ? <Tooltip placement='top' title={row?.surgeon_name} arrow>
                    <div>{row?.surgeon_name?.slice(0, 20) + '...'}</div></Tooltip> :
                    row?.surgeon_name ? row?.surgeon_name : '-'}
            </Box>)
        },
        {
            field: 'amount_net', headerName: `${"Bill Amount"} (${CurrencySymbol})`, flex: 0.12, type: 'number',
            renderCell: ({ row }) => (<Box>{`${CurrencySymbol} ${row?.amount_net ? row?.amount_net : "0"}`}</Box>)
        },
        {
            field: 'bill_type', headerName: "Bill Type", flex: 0.1,
            renderCell: ({ row }) => (<Box component={'div'}>
                <Typography sx={{ textTransform: "capitalize" }}>{row?.bill_type ? row?.bill_type : '-'}</Typography>
                <Typography sx={{ textTransform: "capitalize", fontSize:"0.8vw", color:'gray' }}>{(row?.payment_status && row?.bill_type === "credit") ? row?.payment_status : ''}</Typography>
            </Box>)
        },
        {
            field: "action", flex: 0.08, headerName: t("Action"), headerAlign: "center", align: "center", sortable: false,
            renderCell: (params) => <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                <Tooltip title={t("PrintBill")} placement="top" arrow>
                    <Button emed_tid={'ovr_prt_icon'} onClick={() => { GetOverallPrint(params?.row) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.PrintIcons.default} alt="print" className='eMed_action_img' />
                    </Button>
                </Tooltip>
                {MenuItemTbl(params?.row)}
            </Box>
        }
    ]
    return (
        <Box component={'div'} className='eMed_rts_container'>
            <Box component={"div"} className='eMed_Pharma_rts_header'>
                <Box component={"div"} flex={0.8} display={'flex'} >
                    {AmountsCard("Total Bills", (state?.totalBills || 0), true)}
                    {AmountsCard("Total Amount", (state?.totalAmount || 0))}
                </Box>
                <Box component={"div"} flex={0.2} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginRight={'0.5dvw'}>
                    <Button emed_tid="ot_rpt_saleDetail_flt" className='eMed_usrconf_btn' onClick={() => { setState((prevState) => ({ ...prevState, filterOpen: true })) }}>
                        <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                    </Button>
                    {/* <Button emed_tid="ot_rpt_saleDetail_print" className='eMed_usrconf_btn' disabled={state.disableBtn} onClick={getSalesDetailedPrint}>
                        <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                    <Button emed_tid="ot_rpt_saleDetail_export" className='eMed_Pharma_rts_btn' disabled={state.disableBtn} onClick={getSalesDetailedExcel}>
                        <img src={ImagePaths.ExportIcon.default} alt='export' className='eMed_action_img' />
                    </Button> */}
                </Box>
            </Box>
            <Box component={'div'} className='eMed_Pharma_rts_tbl_card'>
                <DataGrid
                    className='eMed_Pharma_table'
                    rows={state.OverallBillDataList}
                    columns={columns}
                    getRowId={(row) => row.sno}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack className='eMed_conf_nodata'>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    onPageChange={(newPage) => { setState((prevState) => ({ ...prevState, page: newPage })) }}
                    onPageSizeChange={(newPageSize) => setState((prevState) => ({ ...prevState, pageSize: newPageSize }))}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    rowCount={state.OverallBillDataList?.length}
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={state.isLoader}
                />
            </Box>
            <Drawer
                anchor={'right'}
                open={state.filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {state.isErrorMsg && <ToastMsg
                severity={'error'}
                msg={state.isErrorMsgText}
                msgPop={msgClose.bind(this)}
            />}
            {state.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={state.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {state?.selectedCancelBill ?
                <ReasonPopup
                    title={'Are you sure do you want to cancel the bill ?'}
                    AlertPopupClose={popClose}
                    label={"Enter the Cancel Reason"}
                    btntext={'Cancel'}
                    btnvarient={'outlined'}
                    btncolor={'error'}
                    btntext1={'Confirm'}
                    btnvarient1={'contained'}
                    sendCmt={CancelOtBill.bind(this)} />
                : null}
        </Box>
    )
}

export default withTranslation()(OTOverallBills)